export const findFirstNonMaintenanceGateway = (gateways = []) => {
  return gateways.find((gw) => gw?.maintenance?.enabled !== 1) ?? gateways[0];
};
